<template>
  <div :class="`tw-rounded-sm  tw-text-white ${showNavLabel ? 'tw-mb-4' : ''}`">
    <div class="tw-mb-5">
      <v-form
        @submit.prevent="$emit('search', searchText)"
        class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-5 tw-w-full sm:tw-w-auto tw-my-4 sm:tw-my-0"
      >
        <div class="tw-w-full lg:tw-w-auto">
          <v-text-field
            single-line
            dense
            ref="searchText"
            v-model="searchText"
            hide-details
            color="inherit"
            outlined
            label="Search"
            prepend-inner-icon="mdi-magnify"
            class="tw-w-full lg:tw-w-[300px] tw-rounded-xl"
          ></v-text-field>
        </div>
        <div>
          <div class="tw-flex tw-items-stretch tw-justify-center tw-space-x-4 tw-relative">
            <v-btn color="#2b57fb" class="tw-rounded-xl tw-font-bold tw-flex-1 md:tw-w-[150px]" type="submit"
              >Search</v-btn
            >
            <v-btn color="white" outlined class="tw-rounded-xl tw-font-bold tw-flex-1 md:tw-w-[150px]" @click="clear"
              >Clear</v-btn
            >
          </div>
        </div>
      </v-form>
    </div>
    <div v-if="showNavLabel" class="tw-text-left tw-font-bold tw-flex tw-items-center tw-space-x-2">
      <div v-if="getIconName">
        <v-icon>{{ getIconName }}</v-icon>
      </div>
      <div>
        {{ camelPad($route.name) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showNavLabel: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    filter: {
      liveCasino: "live",
      slotCasino: "slots",
    },
    searchText: "",
  }),
  computed: {
    getIconName() {
      switch (this.$route.name) {
        case "Favorites":
          return "mdi-heart";
        case "RecentGames":
          return "mdi-history";
        default:
          return null;
      }
    },
  },
  async beforeMount() {
    if (this.$route.query.q) {
      this.searchText = this.$route.query.q;
      this.$emit("search", this.searchText);
    }
  },
  async mounted() {
    if (this.searchText) this.$refs["searchText"].focus();
  },
  watch: {
    searchText: function (val) {
      this.$emit("onSearchText", val);
    },
    "filter.liveCasino": function (val) {
      this.$emit("liveCasino", val);
    },
    "filter.slotCasino": function (val) {
      this.$emit("slotCasino", val);
    },
  },
  methods: {
    clear() {
      this.searchText = "";
      this.$emit("search", this.searchText);
    },
    camelPad(str) {
      return str
        .replace(/([A-Z]+)([A-Z][a-z])/g, " $1 $2")
        .replace(/([a-z\d])([A-Z])/g, "$1 $2")
        .replace(/([a-zA-Z])(\d)/g, "$1 $2")
        .replace(/^./, function (str) {
          return str.toUpperCase();
        })
        .trim();
    },
  },
};
</script>

<style scoped>
.input-checkbox-provider {
  @apply tw-w-4 tw-h-4 tw-text-red-600 tw-bg-gray-100 tw-rounded tw-border-gray-300 focus:tw-ring-gray-300;
}
.input-checkbox-label {
  @apply tw-ml-2 tw-text-sm tw-font-medium tw-text-white;
}
</style>
